module.exports = __webpack_public_path__ + "static/dona-helena-36b20a6fd05e30ddbc4c250878461362.png";